import { memo } from "react";
import { Link, matchPath, useLocation } from "react-router";

import { ACTIVATION, LOGIN, VISIT_CANCEL, VISIT_CONFIRM } from "@routes/routes";
import { useAppTranslation } from "@hooks/useAppTranslation";
import { useWhiteLabel } from "@hooks/useWhiteLabel";
import DButton from "@UI/components/Atoms/Button/DButton";

import "./Header.scss";

/** Dashboard layout header */
interface HeaderProps {
  authPage?: boolean;
}

const Header = memo(({ authPage = false }: HeaderProps) => {
  const { i18n, secondLanguage } = useAppTranslation();
  const { pathname } = useLocation();
  const matchActivation = matchPath(pathname, ACTIVATION);
  const matchVisitConfirm = matchPath(pathname, VISIT_CONFIRM);
  const matchVisitCancel = matchPath(pathname, VISIT_CANCEL);
  const match = matchActivation || matchVisitCancel || matchVisitConfirm;
  const { config } = useWhiteLabel();

  const img = {
    src: config?.logoUrl?.url || "/static/logoWide.png",
    srcSet: config?.logoUrl?.url || "/static/logoWide.png",
    className: config?.logoUrl?.width ? "" : "landing-header__logo d-mr-16",
    width: config?.logoUrl?.width,
    height: config?.logoUrl?.height,
    alt: config?.name ? `${config.name} logo` : "Alloweat logo",
  };

  const logo = (
    <img
      src={img.src}
      srcSet={img.srcSet}
      className={img.className}
      width={img.width}
      height={img.height}
      alt={img.alt}
    />
  );

  return (
    <div className="landing-header d-flex d-py-8 d-px-8 d-fixed d-justify-space-between d-align-center d-bg-white">
      {authPage ? (
        <a href={match ? undefined : ALLOWEAT_COM}>{logo}</a>
      ) : match ? (
        <a className="d-cursor-pointer">{logo}</a>
      ) : (
        <Link to={LOGIN} className="d-cursor-pointer">
          {logo}
        </Link>
      )}
      <div className="d-flex d-align-center">{/* here go landing links */}</div>
      <div className="d-flex d-align-center">
        <DButton
          onClick={() => i18n.changeLanguage(secondLanguage)}
          label={<p>{secondLanguage.toUpperCase()}</p>}
        />
        {/*<Button color="secondary" to={REGISTER}>*/}
        {/*  {t("auth.login.no_account")}*/}
        {/*</Button>*/}
      </div>
    </div>
  );
});

const ALLOWEAT_COM = "https://alloweat.com/";

export default Header;
